// The <script src> that loads i3-chat-widget-v2.js used to be baked into public/index.html at
// build time via config.getString(), so changing app.aiChatWidget.scriptUrl only took effect on
// the next frontend build/image. Loading it here instead reads the same key through configApi,
// which is populated from the runtime-injected config, so a config/restart-only deploy is enough.
const loadedScriptUrls = new Set<string>();

export function ensureAiChatWidgetScriptLoaded(scriptUrl: string): void {
  // Avoid a raw attribute-selector string (a scriptUrl containing a `"` would break it); compare
  // attribute values directly instead.
  const alreadyPresent =
    loadedScriptUrls.has(scriptUrl) ||
    Array.from(document.scripts).some(s => s.getAttribute('src') === scriptUrl);
  if (alreadyPresent) {
    loadedScriptUrls.add(scriptUrl);
    return;
  }
  loadedScriptUrls.add(scriptUrl);
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  // On failure, allow a later retry (e.g. after a route change re-mounts the widget) instead of
  // permanently treating this URL as loaded.
  script.addEventListener(
    'error',
    () => {
      loadedScriptUrls.delete(scriptUrl);
      script.remove();
    },
    { once: true },
  );
  document.head.appendChild(script);
}
